export default __webpack_public_path__ + "static/media/ConveyorMerger.256.ca09bc05.png";